import NoticesContext from "@jnctn-app/contexts/NoticesContext";
import { useContext, useEffect, useRef } from "react";
import Notice from "./Notice";

// The maximum number rendered at any one time
const MAX_RENDERED = 5;

// Transient notice system. Using the notices context a addTransientNotice function
// is available to add a notice that has automatic removal scheduled
// This component renders the notices and schedules their removal
export default function TransientNotices() {
  const removers = useRef(new Map<string, number>());
  const { transientNotices, removeTransientNotice } = useContext(
    NoticesContext
  );

  useEffect(() => {
    // For each pending clearTimeout, check if the notice is still in existance
    // if not then cancel the timeout
    Array.from(removers.current.keys())
      .filter((key) => !transientNotices.has(key))
      .forEach((key) => {
        window.clearTimeout(removers.current.get(key)!);
        removers.current.delete(key);
      });

    // For each current notice, we want to schedule automatic removal
    // but only if we haven't already scheduled it
    Array.from(transientNotices.keys())
      .filter((key) => !removers.current.has(key))
      .forEach((key) => {
        const [delay] = transientNotices.get(key)!;
        removers.current.set(
          key,
          window.setTimeout(() => {
            removeTransientNotice(key);
            removers.current.delete(key);
          }, delay)
        );
      });
  }, [transientNotices, removeTransientNotice]);

  return (
    <>
      {Array.from(transientNotices)
        .slice(-MAX_RENDERED)
        .map(([key, [, notice]]) => (
          <Notice key={key} {...notice} />
        ))}
    </>
  );
}
